const md5 = require('md5')

const getRoomName = id => {
  return md5(parseInt(id, 10))
}

export default getRoomName
